// src/lib/UploadTray.js
// Floating app-wide upload status pill. Docs & Media uploads run in a
// module-level store (lib/uploadStore) that survives navigation — this pill
// makes that visible from any page, with a Cancel that works anywhere.
import React from 'react';
import { Loader2, X } from 'lucide-react';
import { uploadStore } from './uploadStore';

export default function UploadTray() {
  const [, tick] = React.useReducer((x) => x + 1, 0);
  React.useEffect(() => {
    uploadStore.listeners.add(tick);
    return () => uploadStore.listeners.delete(tick);
  }, []);
  const { uploading, preparing, progress, queuedCount } = uploadStore;
  if (!uploading && !preparing) return null;
  return (
    <div className="fixed bottom-4 right-4 z-[95] flex items-center gap-2.5 bg-gray-900/95 border border-gray-700/70 rounded-full pl-3.5 pr-1.5 py-2 shadow-2xl shadow-black/50 backdrop-blur">
      <Loader2 className="w-4 h-4 text-indigo-400 animate-spin shrink-0" />
      <span className="text-xs font-bold text-zinc-200 whitespace-nowrap">
        {uploading ? `Uploading ${progress}%` : 'Uploading…'}
        {queuedCount > 0 && <span className="text-zinc-500 font-semibold"> · {queuedCount} queued</span>}
      </span>
      <div className="w-20 h-1.5 bg-gray-800 rounded-full overflow-hidden max-md:hidden">
        <div
          className="h-full bg-indigo-500 transition-all duration-300"
          style={{ width: uploading ? `${progress}%` : '0%' }}
        />
      </div>
      <button
        onClick={() => {
          if (!window.confirm('Cancel this upload? Files already finished stay; everything else stops.')) return;
          uploadStore.cancel();
        }}
        title="Cancel upload"
        className="p-1.5 rounded-full text-zinc-500 hover:text-red-300 hover:bg-gray-800"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
